// import React, { useState, useEffect } from 'react';
// import { getHero } from '../api';

// const HeroSection = () => {
//   const [hero, setHero] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [videoError, setVideoError] = useState(false);

//   useEffect(() => {
//     const fetchHero = async () => {
//       try {
//         const data = await getHero();
//         setHero(data);
//       } catch (error) {
//         console.error('Error fetching hero:', error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchHero();
//   }, []);

//   const handleVideoError = (e) => {
//     console.error('Video failed to load:', e);
//     setVideoError(true);
//   };

//   const handleVideoLoaded = () => {
//     console.log('Video loaded successfully');
//     setVideoError(false);
//   };

//   if (loading) {
//     return (
//       <section className="relative w-full h-screen bg-black overflow-hidden">
//         <div className="absolute inset-0 flex items-center justify-center">
//           <div className="text-white text-xl">Loading...</div>
//         </div>
//       </section>
//     );
//   }

//   const shouldShowVideo = hero?.video && !videoError;

//   return (
//     <section className="relative w-full h-screen bg-black overflow-hidden">
//       {/* Orange accent bars */}

//       {/* Hero Content - Video has priority over image */}
//       <div className="absolute inset-0">
//         {shouldShowVideo ? (
//           // Video Hero
//           <>
//             <video
//               key={hero.video}
//               autoPlay
//               loop
//               muted
//               playsInline
//               preload="auto"
//               className="absolute inset-0 w-full h-full object-cover"
//               style={{ objectFit: 'cover', width: '100%', height: '100%' }}
//               onError={handleVideoError}
//               onLoadedData={handleVideoLoaded}
//             >
//               <source src={hero.video} type="video/mp4" />
//               Your browser does not support the video tag.
//             </video>
//             <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/60 z-[1]"></div>
//           </>
//         ) : (
//           // Image Hero (fallback)
//           <>
//             <img
//               src={hero?.image || 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=1200&q=80'}
//               alt="Hero"
//               className="absolute inset-0 w-full h-full object-cover"
//               style={{ objectFit: 'cover', width: '100%', height: '100%' }}
//             />
//             <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/60 z-[1]"></div>
//           </>
//         )}
//       </div>

//       {/* Scroll Indicator */}
//       <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-20">
//         <div className="w-6 h-10 border-2 border-white rounded-full flex items-start justify-center p-2">
//           <div className="w-1 h-3 bg-white rounded-full animate-bounce"></div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default HeroSection;

import React, { useState, useEffect } from 'react';
import { getHero } from '../api';

const HeroSection = () => {
  const [hero, setHero] = useState(null);
  const [loading, setLoading] = useState(true);
  const [videoError, setVideoError] = useState(false);

  useEffect(() => {
    const fetchHero = async () => {
      try {
        const data = await getHero();
        setHero(data);
      } catch (error) {
        console.error('Error fetching hero:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchHero();
  }, []);

  const handleVideoError = (e) => {
    console.error('Video failed to load:', e);
    setVideoError(true);
  };

  const handleVideoLoaded = () => {
    console.log('Video loaded successfully');
    setVideoError(false);
  };

  if (loading) {
    return (
      <section className="relative w-full h-screen bg-black overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-white text-xl">Loading...</div>
        </div>
      </section>
    );
  }

  const shouldShowVideo = hero?.video && !videoError;

  return (
    <section className="relative w-full h-[50vh] md:h-[80vh] lg:h-screen bg-black overflow-hidden">
      {/* Hero Content - Video has priority over image */}
      <div className="absolute inset-0">
        {shouldShowVideo ? (
          // Video Hero
          <>
            <video
              key={hero.video}
              autoPlay
              loop
              muted
              playsInline
              preload="auto"
              className="absolute inset-0 w-full h-full object-cover"
              onError={handleVideoError}
              onLoadedData={handleVideoLoaded}
            >
              <source src={hero.video} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/60 z-[1]"></div>
          </>
        ) : (
          // Image Hero (fallback)
          <>
            <img
              src={hero?.image || 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=1200&q=80'}
              alt="Hero"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/60 z-[1]"></div>
          </>
        )}
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-20">
        <div className="w-6 h-10 border-2 border-white rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;